import type React from 'react';
import { Link } from 'react-router-dom';
import styles from './VulnerabilityDetail.module.css';

interface SourceCardItemProps {
  type: string;
  title: string;
  meta?: string;
  fileExists: boolean;
  linkTo?: string;
}

export const SourceCardItem: React.FC<SourceCardItemProps> = ({ type, title, meta, fileExists, linkTo }) => {
  const content = (
    <>
      <div className={styles.sourceCardHeader}>
        <div className={styles.sourceCardType}>{type}</div>
        {!fileExists && <span className={styles.fileDeletedBadge}>file deleted</span>}
        {linkTo && <span className={styles.sourceCardArrow}>&#8594;</span>}
      </div>
      <div className={styles.sourceCardTitle}>{title}</div>
      {meta && <div className={styles.sourceCardMeta}>{meta}</div>}
    </>
  );

  if (linkTo) {
    return (
      <Link className={styles.sourceCardLink} to={linkTo}>
        {content}
      </Link>
    );
  }
  return <div className={styles.sourceCard}>{content}</div>;
};
